export const N_SMALL_TABLET_MAX_SIZE = 892;

export const DESKTOP_MAX_SIZE = "1250px";
export const BIG_TABLET_MAX_SIZE = "1000px";
export const SMALL_TABLET_MAX_SIZE = `${N_SMALL_TABLET_MAX_SIZE}px`;
export const MOBILE_MIN_SIZE = "768px";
